import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "../styles/BottomNav.css";
import { AuthContext } from "../context/AuthContext";
import { NotificationContext } from "../context/NotificationContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BottomNav = () => {
  const { token, logout } = useContext(AuthContext);
  const { unreadCount: weatherUnreadCount, markAllAsRead } =
    useContext(NotificationContext);
  const navigate = useNavigate();

  const [chatUnreadCount, setChatUnreadCount] = useState(0);

  useEffect(() => {
    const fetchUnreadChat = async () => {
      if (!token) return;
      try {
        const res = await fetch(
          "https://globisun-app.onrender.com/api/chats/unread-count",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const data = await res.json();
        if (res.ok && data?.unreadCount !== undefined) {
          setChatUnreadCount(data.unreadCount);
        }
      } catch (err) {
        console.error("🔴 Error fetching chat unread count:", err.message);
      }
    };

    fetchUnreadChat();
    const interval = setInterval(fetchUnreadChat, 30000);
    return () => clearInterval(interval);
  }, [token]);

  // Mark all weather notifications as read
  const handleAlertsClick = () => {
    markAllAsRead();
  };

  // Home click with horizontal single-line toast
  const handleHomeClick = (e) => {
    e.preventDefault();

    const toastId = toast.warn(
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          fontSize: "10px",
          whiteSpace: "nowrap",
        }}
      >
        ⚠️ Going Home will log you out.
        <button
          style={{
            background: "#000",
            color: "white",
            border: "none",
            padding: "2px 5px",
            borderRadius: "3px",
            cursor: "pointer",
            fontSize: "10px",
          }}
          onClick={() => {
            toast.dismiss(toastId);
            logout();
            navigate("/");
          }}
        >
          Yes
        </button>
        <button
          style={{
            background: "#000",
            color: "white",
            border: "none",
            padding: "2px 5px",
            borderRadius: "3px",
            cursor: "pointer",
            fontSize: "10px",
          }}
          onClick={() => toast.dismiss(toastId)}
        >
          No
        </button>
      </div>,
      {
        autoClose: 4000,
        closeOnClick: true,
        position: "top-right",
      }
    );
  };

  return (
    <nav className="bottom-nav">
      <NavLink to="/" className="nav-item" onClick={handleHomeClick}>
        <span>🏠</span>
        <small>Home</small>
      </NavLink>

      <NavLink to="/dashboard/individual" className="nav-item">
        <span>📊</span>
        <small>Dashboard</small>
      </NavLink>

      <NavLink to="/solartools" className="nav-item">
        <span>🔧</span>
        <small>Tools</small>
      </NavLink>

      <NavLink to="/solar-resources" className="nav-item">
        <span>📚</span>
        <small>Resources</small>
      </NavLink>

      <NavLink
        to="/notifications/weather"
        className="nav-item"
        onClick={handleAlertsClick}
      >
        <span style={{ position: "relative" }}>
          🌤️
          {weatherUnreadCount > 0 && (
            <span className="chat-badge">
              {weatherUnreadCount > 9 ? "9+" : weatherUnreadCount}
            </span>
          )}
        </span>
        <small>Alerts</small>
      </NavLink>

       {/* 
      <NavLink to="/inbox" className="nav-item">
        <span style={{ position: "relative" }}>
          💬
          {chatUnreadCount > 0 && (
            <span className="chat-badge">
              {chatUnreadCount > 9 ? "9+" : chatUnreadCount}
            </span>
          )}
        </span>
        <small>Inbox</small>
      </NavLink> 
      */}
      
    </nav>
  );
};

export default BottomNav;
